import axiosAuth from '../../axiosMain';

async function show(meter_id) {
  let response = await axiosAuth.get('/total_data_consumption/by_meter/' + meter_id);
  return response.data;
}

export default {
  show,
};
